import { createFileRoute } from '@tanstack/react-router';

import { AccountErrorMessage } from 'component/view/Redirects/AccountErrorMessage';

export const Route = createFileRoute('/n/account-error-message')({
  component: AccountErrorMessage,
});
